import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import '../../sass/components/flexibleModules/_components.customerReviewsAutoScroll.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";

const CustomerReviewsAutoScroll = ({ data }) => {
    const [isRendered, setIsRendered] = useState(false);
    const [isRenderedTwo, setIsRenderedTwo] = useState(false);
    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 6000,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    let settingsTwo = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 8000,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        rtl: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
        setIsRenderedTwo(true);
    }, []);

    return (
        <div className="cp-customerReviewsAutoScroll" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-customerReviewsAutoScroll__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                {data.customerReviewsAutoScrollTitle &&
                    <h2>{data.customerReviewsAutoScrollTitle}</h2>
                }
                {data.customerReviewsAutoScrollRepeaterSections &&
                    <div className="cp-customerReviewsAutoScroll__carousel" >
                        {isRendered &&
                            <Slider {...settings}>
                                {data.customerReviewsAutoScrollRepeaterSections.map((gridItems, index) => (
                                    <React.Fragment key={index}>
                                        {gridItems.link ?
                                            <a href={gridItems.link.url} target="_blank" rel="noreferrer" className="cp-customerReviewsAutoScroll__carousel-section l--flex" key={index} style={{ backgroundColor: `${gridItems.gridIndividualBackground}` }}>
                                                <span className="cp-customerReviewsAutoScroll__carousel-section--top">
                                                    {gridItems.title &&
                                                        <h3>{gridItems.title}</h3>
                                                    }
                                                    {gridItems.teaser &&
                                                        <span>{gridItems.teaser}</span>
                                                    }
                                                </span>
                                                <span className="cp-customerReviewsAutoScroll__carousel-section--bottom l--flex">
                                                    {gridItems.authorThumb &&
                                                        <span className="l-authorThumb">
                                                            <GatsbyImage image={getImage(gridItems.authorThumb.gatsbyImage)} alt={gridItems.authorThumb.altText} />
                                                        </span>
                                                    }

                                                    <span className="l-authorDetails">
                                                        {gridItems.authorName &&
                                                            <h4>{gridItems.authorName}</h4>
                                                        }
                                                        {gridItems.authorTitle &&
                                                            <span>{gridItems.authorTitle}</span>
                                                        }
                                                    </span>
                                                </span>
                                            </a>
                                            :
                                            <div className="cp-customerReviewsAutoScroll__carousel-section l--flex" key={index} style={{ backgroundColor: `${gridItems.gridIndividualBackground}` }}>
                                                <span className="cp-customerReviewsAutoScroll__carousel-section--top">
                                                    {gridItems.title &&
                                                        <h3>{gridItems.title}</h3>
                                                    }
                                                    {gridItems.teaser &&
                                                        <span>{gridItems.teaser}</span>
                                                    }
                                                </span>
                                                <span className="cp-customerReviewsAutoScroll__carousel-section--bottom l--flex">
                                                    <span className="l-authorThumb">
                                                        {gridItems.authorThumb &&
                                                            <GatsbyImage image={getImage(gridItems.authorThumb.gatsbyImage)} alt={gridItems.authorThumb.altText} />
                                                        }
                                                    </span>
                                                    <span className="l-authorDetails">
                                                        {gridItems.authorName &&
                                                            <h4>{gridItems.authorName}</h4>
                                                        }
                                                        {gridItems.authorTitle &&
                                                            <span>{gridItems.authorTitle}</span>
                                                        }
                                                    </span>
                                                </span>
                                            </div>
                                        }
                                    </React.Fragment>
                                ))}
                            </Slider>
                        }
                    </div>
                }
                {data.customerReviewsAutoScrollRepeaterSectionsTwo &&
                    <div className="cp-customerReviewsAutoScroll__carousel cp-customerReviewsAutoScroll__carousel-two" >
                        {isRenderedTwo &&
                            <Slider {...settingsTwo}>
                                {data.customerReviewsAutoScrollRepeaterSectionsTwo.map((gridItems, index) => (
                                    <React.Fragment key={index}>
                                        <a href="/" target="_blank" rel="noreferrer" className="cp-customerReviewsAutoScroll__carousel-section l--flex" key={index} style={{ backgroundColor: `${gridItems.gridIndividualBackground}` }}>
                                            <span className="cp-customerReviewsAutoScroll__carousel-section--top">
                                                {gridItems.title &&
                                                    <h3>{gridItems.title}</h3>
                                                }
                                                {gridItems.teaser &&
                                                    <span>{gridItems.teaser}</span>
                                                }
                                            </span>
                                            <span className="cp-customerReviewsAutoScroll__carousel-section--bottom l--flex">
                                                {gridItems.authorThumb &&
                                                    <span className="l-authorThumb">
                                                        <GatsbyImage image={getImage(gridItems.authorThumb.gatsbyImage)} alt={gridItems.authorThumb.altText} />
                                                    </span>
                                                }
                                                <span className="l-authorDetails">
                                                    {gridItems.authorName &&
                                                        <h4>{gridItems.authorName}</h4>
                                                    }
                                                    {gridItems.authorTitle &&
                                                        <span>{gridItems.authorTitle}</span>
                                                    }
                                                </span>
                                            </span>
                                        </a>
                                    </React.Fragment>
                                ))}
                            </Slider>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default CustomerReviewsAutoScroll;